import { formats } from '@shared/intlConstants';
import { isInContextEditorEnabled } from '@shared/lib/tolgee/helpers';
import withTolgeeProvider from '@shared/lib/tolgee/withTolgeeProvider';
import { getLocaleDirection } from '@shared/util/locale';
import { ReactNode, useEffect } from 'react';
import { IntlProvider } from 'react-intl';

type Props = Required<Pick<IntlProvider['props'], 'locale' | 'messages'>> & {
  children: ReactNode;
};
const LocalizationProvider = ({ locale, messages, children }: Props) => {
  const direction = getLocaleDirection(locale);
  useEffect(() => {
    document.documentElement.setAttribute('lang', locale);
    document.documentElement.setAttribute('dir', direction);
  }, [locale, direction]);
  return (
    <IntlProvider
      textComponent="span"
      // use the Western Arabic numerals for standard Arabic (Chrome's way)
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/numberingSystem#adding_a_numbering_system_via_the_locale_string
      locale={locale === 'ar' ? 'ar-u-nu-latn' : `${locale}-u-ca-gregory`}
      messages={messages}
      formats={formats}
    >
      {children}
    </IntlProvider>
  );
};

export default isInContextEditorEnabled()
  ? withTolgeeProvider(LocalizationProvider)
  : LocalizationProvider;
